import Choices from 'choices.js';

class ComponentForm {
  private form?: HTMLFormElement;
  private inputs?: NodeListOf<HTMLInputElement | HTMLTextAreaElement>;
  private choicesInstances: Choices[] = [];

  constructor(formElement: HTMLFormElement) {
    if (!formElement) return;

    this.form = formElement;
    this.inputs = this.form.querySelectorAll('input, textarea');
    this.choicesInstances = [];

    this.initChoices();
    this.initInputHandlers();
    this.initFileInputs();
    this.initResetListener();
  }

  private initChoices(): void {
    if (this.form) {
      const selects = this.form.querySelectorAll<HTMLSelectElement>('select');
      selects.forEach(select => {
        const choicesInstance = new Choices(select, {
          searchEnabled: false,
          searchChoices: false,
          itemSelectText: '',
          shouldSort: false
        });
        this.choicesInstances.push(choicesInstance);
      });
    }
  }

  private initInputHandlers(): void {
    if (this.inputs) {
      this.inputs.forEach(input => {
        this.updateInputState(input);
        input.addEventListener('focus', () => this.handleFocus(input));
        input.addEventListener('blur', () => this.handleBlur(input));
      });
    }
  }

  private handleFocus(input: HTMLInputElement | HTMLTextAreaElement): void {
    input.closest('.contact-form__item')?.classList.add('focused');
  }

  private handleBlur(input: HTMLInputElement | HTMLTextAreaElement): void {
    const parent = input.closest('.contact-form__item');
    if (!parent) return;
    parent.classList.remove('focused');
    this.updateInputState(input);
  }

  private updateInputState(input: HTMLInputElement | HTMLTextAreaElement): void {
    const parent = input.closest('.contact-form__item');
    if (!parent) return;
    if (input.value.trim() !== '') {
      parent.classList.add('filled');
    } else {
      parent.classList.remove('filled');
    }
  }

  private initResetListener(): void {
    document.addEventListener('wpcf7mailsent', (event) => {
      if (event.target === this.form) {
        this.resetFormState();
      }
    });
  }

  private initFileInputs(): void {
    if (!this.form) return
    const fileInputItems = this.form.querySelectorAll<HTMLDivElement>('.contact-form__file');

    fileInputItems.forEach(item => {
      const input = item.querySelector<HTMLInputElement>('input[type="file"]');
      const textSpan = item.querySelector<HTMLSpanElement>('.contact-form__file-text');

      if (!input || !textSpan) return;

      const defaultText = textSpan.dataset.defaultText || '';

      input.addEventListener('change', () => {
        if (input.files && input.files.length > 0) {
          // Affiche le nom du fichier sélectionné
          textSpan.textContent = input.files[0].name;
          textSpan.classList.add('active')
        } else {
          // Remet le texte par défaut si aucun fichier n'est choisi
          textSpan.textContent = defaultText;
          textSpan.classList.remove('active')
        }
      });
    });
  }

  private resetFormState(): void {
    if (this.inputs) {
      this.inputs.forEach(input => {
        const parent = input.closest('.contact-form__item');
        parent?.classList.remove('filled', 'focused');
      });
      this.choicesInstances.forEach(instance => {
        instance.clearStore();
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll<HTMLFormElement>('.contact-form, form, .form');
  forms.forEach(form => new ComponentForm(form));
});